<template>
  <component
    :is="tag"
    :aria-label="seoName"
    class="inline-flex items-center gap-1"
  >
    <span class="sr-only">{{ seoName }}</span>
    <span v-if="emoji">{{ emoji }}</span>
    <span> ÆRO.NOW </span>
  </component>
</template>

<script setup>
defineProps({
  emoji: {
    type: String,
    default: '',
  },
  tag: {
    type: String,
    default: 'span', // Can be 'h1', 'div', 'p', etc.
  },
  seoName: {
    type: String,
    default: 'AERO.NOW',
  },
})
</script>
